import React, { useState, useContext } from "react";
import Drawer from "@material-ui/core/Drawer";
import Navbar from "../PortalNavbar/Navbar";
import { useMediaQuery } from "@material-ui/core";
import { useNavigate } from "react-router";
import classes from "./sidebar.module.css";

import { AuthContext } from "../../context/AuthContext";

import main_menu from "./main_menu";

export function Sidebar(props) {
  const router = useNavigate();
  const { profile, sidebarNotifications } = useContext(AuthContext);
  const { activeText, activeSubText } = props;
  const isDesktop = useMediaQuery("(min-width: 1200px)");
  const [show, setShow] = React.useState(true);
  const [openDrawer, setOpenDrawer] = React.useState(false);

  React.useEffect(() => {}, [isDesktop]);

  React.useEffect(() => {
    setShow(true);
  }, []);

  const navigateTo = (url, isSelf) => {
    if (isSelf) {
      return router(url);
    } else {
      return (window.location.href = url);
    }
  };

  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className={classes.root}>
      <Navbar open={openDrawer} setOpen={setOpenDrawer} />

      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div className={classes.navbar_sidebar_extension}>
          <img
            src="/BrandLinkLogoBlue.png"
            alt="logo"
            className={classes.sidebar_logo}
          ></img>
        </div>
        {/* <Divider /> */}

        {main_menu.map((text, index) => {
          let sidebarIcon = <text.Icon color="rgba(0, 0, 0, 0.75)" />;

          if (activeText === text.title || activeIndex === index) {
            sidebarIcon = <text.Icon color="rgba(0, 88, 220, 1)" />;
          }

          return (
            <div className={classes.sidebar_tab_item}>
              <div
                className={`${classes.list_item_content} ${
                  activeText === text.title
                    ? classes.active_list_item_content
                    : ""
                }`}
                onClick={(e) => {
                  if (!text.coming_soon) {
                    navigateTo(text.url, text.isSelf);
                  }
                }}
                onMouseEnter={() => setActiveIndex(index)}
                onMouseLeave={() => setActiveIndex(null)}
              >
                <div className={classes.sidebar_icon}>{sidebarIcon}</div>

                <p
                  className={
                    activeText === text.title
                      ? classes.active_sidebar_text
                      : activeIndex === index
                      ? classes.hovered_sidebar_text
                      : classes.sidebar_text
                  }
                >
                  {text.title}
                </p>
                {text.coming_soon && (
                  <div className={classes.coming_soon}>Coming Soon</div>
                )}
                {/* {text.title === "Your Inboxes" &&
                  sidebarNotifications.inbox > 0 && (
                    <div className={classes.notification_dot_blue}>
                      {sidebarNotifications.inbox}
                    </div>
                  )}
                {text.title === "Settings" &&
                  sidebarNotifications.disconnected_emails > 0 && (
                    <div className={classes.notification_dot_orange}>!</div>
                  )} */}
              </div>
            </div>
          );
        })}

        <div className={classes.sidebar_bottom_layout}>
          {/* <div className={classes.share_refferal_promotion}>
            <p className={classes.share_refferal_subtitle}>
              Become an affiliate
            </p>
          </div> */}
          <div className={classes.sidebar_bottom_options}>
            <div className={classes.iconWrapper}>
              <a
                href="https://www.instagram.com/brandlink.co/"
                target="_blank"
                rel="noreferrer"
              >
                <InstaIcon />
              </a>

              <a
                href="https://www.instagram.com/brandlink.co/"
                target="_blank"
                rel="noreferrer"
              >
                <YoutubeIcon />
              </a>
            </div>
            <div
              style={{
                flexGrow: 1,
                display: "flex",
                alignItems: "flex-end",

                width: "100%",
              }}
            >
              <p
                style={{
                  color: "#AFAFAF",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                @{new Date().getFullYear()} BrandLink
              </p>
            </div>
          </div>
        </div>
      </Drawer>

      <main className={`${classes.content}`}>
        {/* <div className={classes.toolbar} /> */}
        {props.childComponent}
      </main>
    </div>
  );
}

function SidebarIcon(props) {
  return (
    <div className={classes.sidebar_icon}>
      <img
        className={classes.sidebar_icon_image}
        src={props.sidebar_icon}
        alt="icon"
      ></img>
    </div>
  );
}

function InstaIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0C8.74101 0 8.33234 0.0138258 7.0524 0.0722013C5.77514 0.13047 4.90283 0.333355 4.13952 0.629949C3.35041 0.936617 2.6812 1.34696 2.0141 2.01406C1.34696 2.68117 0.936617 3.35045 0.629984 4.13956C0.333319 4.90283 0.130505 5.77514 0.0721656 7.0524C0.0137901 8.33234 0 8.74101 0 12C0 15.259 0.0137901 15.6677 0.0721656 16.9476C0.130505 18.2249 0.333319 19.0972 0.629984 19.8604C0.936653 20.6495 1.347 21.3188 2.0141 21.9859C2.68124 22.653 3.35041 23.0634 4.13952 23.3701C4.90283 23.6666 5.77514 23.8695 7.0524 23.9278C8.33234 23.9862 8.74101 24 12 24C15.259 24 15.6677 23.9862 16.9476 23.9278C18.2249 23.8695 19.0972 23.6666 19.8604 23.3701C20.6495 23.0634 21.3188 22.653 21.9859 21.9859C22.653 21.3188 23.0634 20.6495 23.3701 19.8604C23.6666 19.0972 23.8695 18.2249 23.9278 16.9476C23.9862 15.6677 24 15.259 24 12C24 8.74101 23.9862 8.33234 23.9278 7.0524C23.8695 5.77514 23.6666 4.90283 23.3701 4.13956C23.0634 3.35045 22.653 2.68117 21.9859 2.01406C21.3188 1.34696 20.6495 0.936617 19.8604 0.629949C19.0972 0.333355 18.2249 0.13047 16.9476 0.0722013C15.6677 0.0138258 15.259 0 12 0ZM12 2.16215C15.2041 2.16215 15.5837 2.1744 16.849 2.23213C18.019 2.28547 18.6544 2.48096 19.0772 2.6453C19.6374 2.86301 20.0371 3.12302 20.457 3.54294C20.877 3.96286 21.137 4.36263 21.3547 4.92273C21.519 5.34558 21.7145 5.98099 21.7679 7.15097C21.8256 8.41633 21.8379 8.79588 21.8379 12C21.8379 15.2041 21.8256 15.5837 21.7679 16.849C21.7145 18.019 21.519 18.6544 21.3547 19.0772C21.137 19.6374 20.877 20.0371 20.457 20.457C20.0371 20.877 19.6374 21.137 19.0773 21.3547C18.6544 21.519 18.019 21.7145 16.849 21.7679C15.5839 21.8256 15.2044 21.8379 12 21.8379C8.79563 21.8379 8.41619 21.8256 7.15097 21.7678C5.98096 21.7145 5.34558 21.519 4.92277 21.3547C4.36259 21.137 3.96286 20.877 3.54297 20.457C3.12306 20.0371 2.86301 19.6374 2.6453 19.0773C2.48096 18.6544 2.28551 18.019 2.23213 16.849C2.1744 15.5837 2.16215 15.2041 2.16215 12C2.16215 8.79588 2.1744 8.41633 2.23213 7.15097C2.28551 5.98096 2.48096 5.34558 2.6453 4.92277C2.86301 4.36259 3.12306 3.96286 3.54294 3.54297C3.96286 3.12302 4.36263 2.86301 4.92273 2.6453C5.34558 2.48096 5.98099 2.28547 7.15097 2.23213C8.41633 2.1744 8.79588 2.16215 12 2.16215"
        fill="#AFAFAF"
      />
      <path
        d="M12 16C9.79083 16 7.99998 14.2092 7.99998 12C7.99998 9.79083 9.79083 7.99998 12 7.99998C14.2091 7.99998 16 9.79083 16 12C16 14.2092 14.2091 16 12 16ZM12 5.83784C8.5967 5.83784 5.83783 8.59671 5.83783 12C5.83783 15.4033 8.5967 18.1622 12 18.1622C15.4033 18.1622 18.1621 15.4033 18.1621 12C18.1621 8.59671 15.4033 5.83784 12 5.83784M19.8456 5.59437C19.8456 6.38969 19.2009 7.03436 18.4056 7.03436C17.6104 7.03436 16.9656 6.38969 16.9656 5.59437C16.9656 4.79908 17.6104 4.15434 18.4056 4.15434C19.2009 4.15434 19.8456 4.79908 19.8456 5.59437"
        fill="#AFAFAF"
      />
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0008 3.99295H7.00077C6.33366 3.95269 5.6656 4.05444 5.04073 4.29147C4.41586 4.52851 3.84839 4.89543 3.37582 5.368C2.90324 5.84058 2.53632 6.40804 2.29929 7.03292C2.06225 7.65779 1.96051 8.32585 2.00077 8.99295V14.993C1.96051 15.6601 2.06225 16.3281 2.29929 16.953C2.53632 17.5779 2.90324 18.1453 3.37582 18.6179C3.84839 19.0905 4.41586 19.4574 5.04073 19.6944C5.6656 19.9315 6.33366 20.0332 7.00077 19.993H17.0008C17.6679 20.0332 18.3359 19.9315 18.9608 19.6944C19.5857 19.4574 20.1531 19.0905 20.6257 18.6179C21.0983 18.1453 21.4652 17.5779 21.7022 16.953C21.9393 16.3281 22.041 15.6601 22.0008 14.993V8.99295C22.041 8.32585 21.9393 7.65779 21.7022 7.03292C21.4652 6.40804 21.0983 5.84058 20.6257 5.368C20.1531 4.89543 19.5857 4.52851 18.9608 4.29147C18.3359 4.05444 17.6679 3.95269 17.0008 3.99295ZM13.8908 13.023L11.4208 14.503C10.4208 15.103 9.60077 14.643 9.60077 13.473V10.503C9.60077 9.33295 10.4208 8.87295 11.4208 9.47295L13.8908 10.953C14.1004 11.033 14.2807 11.1749 14.4079 11.3597C14.5351 11.5445 14.6032 11.7636 14.6032 11.988C14.6032 12.2123 14.5351 12.4314 14.4079 12.6162C14.2807 12.801 14.1004 12.9429 13.8908 13.023Z"
        fill="#AFAFAF"
      />
    </svg>
  );
}
